module.exports = __webpack_public_path__ + "media/images/photos/16-df3a213d5de89fd7a16e2ec434e840b2.jpg";